import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";

export function Layout() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  async function onLogout() {
    await auth.logout();
    navigate("/login", { replace: true });
  }

  if (auth.status !== "authed") return null; // RequireAuth gere

  const linkClass = (path: string) =>
    location.pathname.startsWith(path) ? "nav-link active" : "nav-link";

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-head">
          <span className="sidebar-logo">🧭</span>
          <strong>Orientation</strong>
        </div>
        <nav>
          <Link to="/carte" className={linkClass("/carte")}>
            🗺️ Carte du parc
          </Link>
          <Link to="/questions" className={linkClass("/questions")}>
            ❓ Banque de questions
          </Link>
          <Link to="/parcours" className={linkClass("/parcours")}>
            🧩 Parcours
          </Link>
          <Link to="/sessions" className={linkClass("/sessions")}>
            🏁 Sessions
          </Link>
        </nav>
        <div className="sidebar-foot">
          <div className="user">
            <span className="user-name">{auth.user.full_name ?? auth.user.email}</span>
            <span className="user-role">{auth.user.role}</span>
          </div>
          <button onClick={onLogout} className="btn-logout">Déconnexion</button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
